import React from "react";
import { useTranslation } from "react-i18next";

function AdditionalInformationForm({ formik, data, handleFlight, handleHotel, flight, hotel }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="mt-14 sm:mt-20 sm:mb-4 booking-modal__car-info__dates">
        <h5>{t("additional_information").toUpperCase()}</h5>
      </div>{" "}
      <h1>{""}</h1>
      {data?.type === "self_drive" ? (
        <span>
          <label>{t("driver_name")}</label>
          <input
            placeholder={t("driver_name")}
            {...formik.getFieldProps("additional_informations.driver_name")}
          ></input>
        </span>
      ) : (
        <span>
          <label>{t("guest_name")}</label>
          <input placeholder={t("guest_name")} {...formik.getFieldProps("additional_informations.guest_name")}></input>
        </span>
      )}
      {/* <span>
        <label>{t("booker_name")}</label>
        <input
          placeholder={t("booker_name")}
          {...formik.getFieldProps("additional_informations.booker_name")}
        ></input>
      </span> */}
      <span>
        <label>{t("passanger_total")}</label>
        <input
          type="number"
          placeholder={t("passanger_total")}
          {...formik.getFieldProps("additional_informations.passanger_total")}
        ></input>
      </span>
      <span>
        <label>{t("luggage_total")}</label>
        <input
          type="number"
          placeholder={t("luggage_total")}
          {...formik.getFieldProps("additional_informations.luggage_total")}
        ></input>
      </span>
      {data?.type !== "transfer_service" ? (
        <>
          <span>
            <label>
              {t("return_flight")} <b>*</b>
            </label>
            <input type="file" multiple accept="image/jpeg, image/png, image/jpg" onChange={handleFlight} />
            {flight && Object.keys(flight).length > 0 && (
              <p className="mt-1 text-sm !text-green-600">
                ✓ {Object.keys(flight).length} file uploaded:
                {Object.keys(flight).map((key, index) => (
                  <span key={key} className="ml-1">
                    {flight[key]?.name}
                    {index < Object.keys(flight).length - 1 ? "," : ""}
                  </span>
                ))}
              </p>
            )}
          </span>

          <span>
            <label>{t("hotel_accomodation")} (optional)</label>
            <input type="file" multiple accept="image/jpeg, image/png, image/jpg" onChange={handleHotel} />
            {hotel && Object.keys(hotel).length > 0 && (
              <p className="mt-1 text-sm !text-green-600">
                ✓ {Object.keys(hotel).length} file uploaded:
                {Object.keys(hotel).map((key, index) => (
                  <span key={key} className="ml-1">
                    {hotel[key]?.name}
                    {index < Object.keys(hotel).length - 1 ? "," : ""}
                  </span>
                ))}
              </p>
            )}
          </span>

          <span>
            <label>{t("flight_detail")}</label>
            <textarea
              placeholder={t("airline_name")}
              {...formik.getFieldProps("additional_informations.flight_detail")}
            ></textarea>
          </span>
          <span>
            <label>{t("hotel_detail")}</label>
            <textarea
              placeholder={t("hotel_name")}
              {...formik.getFieldProps("additional_informations.hotel_detail")}
            ></textarea>
          </span>
        </>
      ) : null}
      <span>
        <label>{t("disability_needs")}</label>
        <textarea
          placeholder={t("wheelchair")}
          {...formik.getFieldProps("additional_informations.disability_needs")}
        ></textarea>
      </span>
    </>
  );
}

export default AdditionalInformationForm;
